import { render, staticRenderFns } from "./RefundRequestsTable.vue?vue&type=template&id=3223e3d3"
import script from "./RefundRequestsTable.vue?vue&type=script&lang=js"
export * from "./RefundRequestsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports